module.exports = __webpack_public_path__ + "img/1.1ba0f850.jpg";